import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModuleSelectionFilter } from 'app/shared/filters/module-selection.filter';
import { ModuleSelection } from 'app/shared/models/module-selection.model';
import { ModuleService } from 'app/shared/services/module.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-module-selection',
  templateUrl: './module-selection.component.html',
  styleUrls: ['./module-selection.component.scss']
})

export class ModuleSelectionComponent implements OnInit {

  private static readonly inactiveSelectedModulesMessage: string = "Inactive selected module(s) detected. Please uncheck these module(s) and save again.";

  @Input() title: string;
  @Input() transactionFeeFieldLabel: string;
  @Input() refundCostFieldLabel: string;
  @Input() noModulesAvailableMessage: string;
  @Input() sourceUrl: string;
  @Input() displayTransactionFee: boolean = false;
  @Input() companyId: number;
  @Input() userId: string;

  form: FormGroup;
  modules: Array<ModuleSelection>;
  moduleSelectionFilter: ModuleSelectionFilter;

  get formModules(): FormArray {
    return this.form.get('formModules') as FormArray;
  }

  constructor(public moduleService: ModuleService, protected activeModal: NgbActiveModal, private formBuilder: FormBuilder, protected toastrService: ToastrService) {
    this.form = this.formBuilder.group({
      currentObjectId: [''],
      formModules: new FormArray([]),
    });
  }

  ngOnInit() {
    this.moduleSelectionFilter = new ModuleSelectionFilter();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.moduleSelectionFilter == null) {
      this.ngOnInit();
    }

    if (changes.companyId || changes.userId) {
      if (changes.companyId) {
        this.moduleSelectionFilter.CompanyId = this.companyId;
      }

      if (changes.userId) {
        this.moduleSelectionFilter.UserId = this.userId;
      }

      this.updateFormModules();
    }
  }

  private updateFormModules() {
    this.moduleService.getCollection<ModuleSelection>(this.sourceUrl, this.moduleSelectionFilter, (collection) => {
      this.modules = collection;
      this.addModulesToForm();
    });
  }

  private addModulesToForm() {
    this.formModules.clear();
    this.modules.forEach(module => {
      var moduleFields = this.buildModuleFields(module);
      this.formModules.push(moduleFields);
    });
  }

  private buildModuleFields(moduleSelection: ModuleSelection) {
    var moduleFields = this.formBuilder.group({
      ModuleId: [moduleSelection.ModuleId],
      Name: [moduleSelection.Name],
      IsActive: [moduleSelection.IsActive],
      IsChecked: [moduleSelection.IsChecked],
      TransactionFee: [moduleSelection.TransactionFee],
      RefundCost: [moduleSelection.RefundCost]
    });

    return moduleFields;
  }

  public hasInactiveSelectedModules() {
    for (let formModule of this.form.value.formModules) {
      if (!formModule.IsActive && formModule.IsChecked) {
        this.toastrService.warning(ModuleSelectionComponent.inactiveSelectedModulesMessage);
        return true;
      }
    }

    return false;
  }

  public getSelected() {
    var selectedModules: Array<ModuleSelection> = [];

    for (let formModule of this.form.value.formModules) {
      if (formModule.IsChecked) {
        selectedModules.push(new ModuleSelection(formModule.ModuleId, formModule.Name, formModule.IsActive, formModule.IsChecked, formModule.TransactionFee, formModule.RefundCost));
      }
    }

    return selectedModules;
  }
}
